
import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { FiPlus, FiRefreshCcw } from "react-icons/fi";
import useToggleDrawer from "hooks/useToggleDrawer";
import PageTitle from "components/Typography/PageTitle";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import TrustedCompanyDrawer from "components/drawer/TrustedCompanyDrawer";
import TrustedCompanyTable from "../components/TrustedCompany/TrustedCompanyTable";
import useAsync from "hooks/useAsync";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import TrustedCompaniesServices from "services/TrustedCompaniesServices";

const TrustedCompanies = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const { toggleDrawer, setIsUpdate } = useContext(SidebarContext);
  const { title, serviceId, setServiceId } = useToggleDrawer();

  const [searchText, setSearchText] = useState("");
  const [status, setStatus] = useState(false);

  const { data, loading, error } = useAsync(() =>
    TrustedCompaniesServices.getAllTrustedCompanies()
  );

  const safeData = Array.isArray(data?.data?.data)
    ? data.data.data
    : Array.isArray(data?.data)
      ? data.data
      : [];

  const isAdmin = Number(adminInfo?.id) === 1;

  const hasPermission = (action) =>
    isAdmin ||
    adminInfo?.permission?.some(
      (permission) =>
        permission.id_tab === "trusted companies" &&
        Number(permission[action]) === 1
    );

  const hideView = hasPermission("view");
  const hideDelete = hasPermission("delete");
  const hideEdit = hasPermission("edit");
  const hideAdd = hasPermission("add");

  useEffect(() => {
    setStatus(Boolean(data?.data?.status ?? data?.status));
  }, [data]);

  const filteredData = safeData.filter((company) =>
    (company?.company_name || "")
      .toLowerCase()
      .includes(searchText.trim().toLowerCase())
  );

  const handleRefresh = () => {
    setIsUpdate(true);
  };

  if (!hideView) {
    return null;
  }

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <PageTitle sidebar={sidebar().sidebar} />

<MainDrawer>
  <TrustedCompanyDrawer
    id={serviceId}
    isViewMode={false}
  />
</MainDrawer>

      <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
        <CardBody>
          <form
            className="gap-4 flex items-center"
            onSubmit={(event) => event.preventDefault()}
          >
            <div className="flex-1">
              <Input
                className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                type="search"
                name="search"
                value={searchText}
                autoComplete="off"
                onChange={(event) => setSearchText(event.target.value)}
                placeholder="Search company name"
              />
            </div>

{hideAdd && (
  <Button
    type="button"
onClick={() => {
  setServiceId("");
  setIsUpdate(false);
  toggleDrawer();
}}
    className="w-56 rounded-md h-10"
  >
    <span className="mr-3">
      <FiPlus />
    </span>
    Add Company
  </Button>
)}

            <button
              type="button"
              onClick={handleRefresh}
              className="cursor-pointer"
              aria-label="Refresh trusted companies"
            >
              <FiRefreshCcw />
            </button>
          </form>
        </CardBody>
      </Card>

      <DataWrapper loading={loading} error={error} status={status}>
        {filteredData.length > 0 ? (
          <TableContainer
            className="mb-8"
            style={{
              maxHeight: "65vh",
              overflow: "auto",
              scrollbarWidth: "thin",
            }}
          >
            <Table>
              <TableHeader className="custom-table-header capitalize sticky top-0 z-10">
                <tr>
                  <TableCell className="text-center">Sl.No.</TableCell>
                  <TableCell className="text-center">Company Name</TableCell>
                  <TableCell className="text-center">Company Logo</TableCell>
                  <TableCell className="text-center">Actions</TableCell>
                </tr>
              </TableHeader>

              <TrustedCompanyTable
                companyData={filteredData}
                hideEdit={hideEdit}
                hideDelete={hideDelete}
              />
            </Table>
          </TableContainer>
        ) : (
          <NotFound title="There are no Trusted Companies" />
        )}
      </DataWrapper>
    </>
  );
};

export default TrustedCompanies;
